module.exports = __webpack_public_path__ + "img/01d.7b03581f.svg";